import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../i18n';

export default function CookiePolicy() {
  const { t } = useLanguage();
  const tt = (k: string) => t('cookiePolicy', k);
  const title = tt('title');

  return (
    <article className="cookie-policy-page">
      <Helmet>
        <title>{title} — RetroGameUp</title>
      </Helmet>
      <h1>{title}</h1>
      <p className="cookie-policy-updated">{tt('lastUpdated')}</p>
      <p className="cookie-policy-intro">{tt('intro')}</p>

      <section>
        <h2>{tt('langPrefTitle')}</h2>
        <p>{tt('langPrefBody')}</p>
      </section>

      <section>
        <h2>{tt('videoCacheTitle')}</h2>
        <p>{tt('videoCacheBody')}</p>
      </section>

      <section>
        <h2>{tt('youtubeTitle')}</h2>
        <p>{tt('youtubeBody')}</p>
        <p className="cookie-policy-note">
          {tt('youtubeNotePre')}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            {tt('youtubeNoteGoogleLink')}
          </a>
          {tt('youtubeNoteMid')}
          <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer">
            {tt('youtubeNoteYouTubeLink')}
          </a>
          {tt('youtubeNotePost')}
        </p>
      </section>

      <section>
        <h2>{tt('analyticsTitle')}</h2>
        <p>{tt('analyticsBody')}</p>
      </section>

      <section>
        <h2>{tt('managingTitle')}</h2>
        <p>{tt('managingBody')}</p>
      </section>
    </article>
  );
}
